import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import UserPage from "../../common/UserPage/UserPage";
import UserSideBar from "../../common/UserSidebar/UserSideBar";
import CustomSlider from "./CustomSlider";
import ExpertSlider from "../TherapistInfo/ExpertSlider";
import Footer from "../../common/Footer/Footer";
import Categories from "./Categories";
import CtaImage from "./CtaImage";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { getCurrentUser } from "../../redux/userSlice";

function UserMainPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentUser, loading, error } = useSelector((state) => state.users);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && !currentUser && !loading) {
      dispatch(getCurrentUser())
        .unwrap()
        .catch((err) => {
          if (err === "User Not Found" || err?.includes?.("bulunamadı")) {
            navigate("/signIn");
          }
        });
    } else if (!token) {
      navigate("/signIn");
    }
  }, [dispatch, currentUser, loading, navigate]);

  if (loading) return <p>Yükleniyor...</p>;
  if (error || !currentUser) return <Navigate to="/signIn" replace />;

  return (
    <>
      <UserPage customImage={currentUser?.picture} />

      <div className="flex flex-col lg:flex-row w-full p-2 mt-[-20px]">
        {/* Sidebar */}
        <div className="flex-shrink-0">
          <UserSideBar />
        </div>

        {/* Ana içerik */}
        <div className="flex flex-col flex-1 min-w-0 px-3 md:px-5 mt-4 gap-4">

          {/* Karşılama */}
          <div>
            <h1 className="text-lg md:text-2xl font-poppins font-semibold text-text">
              {t('welcome')}, {currentUser?.name} {currentUser?.surname}
            </h1>
            <p className="text-xs md:text-sm font-poppins text-text/60 mt-0.5">
              {t('userMainPageTitle')}
            </p>
          </div>

          {/* Slider */}
          <CustomSlider />

          {/* Kategoriler + CTA - eşit yükseklikte */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Categories />
            <CtaImage />
          </div>

        </div>
      </div>

      {/* Terapistler */}
      <div className="mt-8 mb-2">
        <p className="text-center font-roboto text-xl md:text-2xl text-text mb-4 font-medium">
          {t('onlinePsychologists')}
        </p>
        <ExpertSlider bgColor="bg-background" />
      </div>

      <Footer />
    </>
  );
}

export default UserMainPage;
